import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { AuthGuard } from './components/auth-guard';
import { Layout } from './components/layout';
import { Dashboard } from './pages/dashboard';
import { DocumentsPage } from './pages/document/document-page';
import { EventsPage } from './pages/events';
import { MachinesPage } from './pages/machines';
import { PromptsPage } from './pages/prompts';
import { SettingsPage } from './pages/settings';

function App() {
  return (
    <BrowserRouter>
      <AuthGuard>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="documents/*" element={<DocumentsPage />} />
            <Route path="events" element={<EventsPage />} />
            <Route path="machines" element={<MachinesPage />} />
            <Route path="prompts" element={<PromptsPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Routes>
      </AuthGuard>
    </BrowserRouter>
  );
}

export default App;
